<template>
  <div>
    <a-modal
      width="76%"
      title="审核详情"
      destroy-on-close
      :visible.sync="auditShow"
      append-to-body
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="container" v-if="tableData.length != 0">
        <ul class="time-horizontal">
          <li v-for="(item, index) in tableData" :key="index">
            <span
              class="time"
              v-if="
                item.checkStatus == '审核驳回' || item.checkStatus == '审核通过'
              "
              >{{ item.updateTime }}</span
            >
            <b></b>
            <div class="box">
              <div class="auditor">
                <i class="iconfont icon-daohang_fuwuguanlishenhe"></i>
                审&ensp;核&ensp;人：
                <span>{{ item.realName }}</span>
              </div>
              <div class="auditor">
                <i class="iconfont icon-tongguo"></i>
                审核状态：
                <span>{{ item.checkStatus }}</span>
              </div>
              <div class="auditor" v-if="item.checkStatus == '审核驳回'">
                <i class="iconfont icon-wenhao"></i>
                驳回原因：
                <span>{{ item.checkReason }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <img
          style="width: 50%; display: block; margin: 0 auto"
          src="@/assets/images/audit/empty.png"
          alt=""
        />
        <p
          style="
            position: absolute;
            bottom: 150px;
            left: calc(50% - 0.8rem);
            font-size: 24px;
          "
          class="text_style_1"
        >
          暂无审核记录
        </p>
      </div>
    </a-modal>
  </div>
</template>
  
  <script>
import { postAction } from "@/api";
export default {
  data() {
    return {
      auditShow: false,
      tableData: [],
    };
  },
  methods: {
    init(data) {
      this.auditShow = true;
      this.getResourseAudioDetail(data.id);
    },
    getStatus(v) {
      const types = new Map([
        ["1", "待审核"],
        ["2", "已通过"],
        ["3", "已驳回"],
      ]);
      return types.get(v);
    },
    getResourseAudioDetail(taskId) {
      postAction(`/audit/lxAuditTask/getAuditTimeLine?taskId=${taskId}`).then(
        (res) => {
          if (res.code == 200) {
            this.tableData = res.result.map((item) => {
              console.log("🚀 ~ getResourseAudioDetail ~ item:", item);
              return {
                // name: res.data.result.name,
                // majorId_dictText: res.data.result.majorId_dictText,
                // resourceType_dictText: res.data.result.resourceType_dictText,
                realName: item.realname,
                updateTime: item.auditTime,
                checkStatus: item.auditState,
                checkReason: item.remark,
                //majorId_dictText: res.data.result.majorId_dictText,
              };
            });
          }
        }
      );
    },
    handleCancel() {
      this.auditShow = false;
    },
    handleOk() {
      this.auditShow = false;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
::v-deep .el-dialog {
  overflow: hidden;
}
.container {
  overflow: hidden;
  padding: 30px;
}
/*横向时间轴*/
.time-horizontal {
  list-style-type: none;
  border-top: 8px solid #c7e5ff;
  max-width: 100%;
  padding: 0px;
  margin: 0px;
  .time {
    position: absolute;
    top: -30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
}

.time-horizontal li {
  float: left;
  position: relative;
  width: 25%;
  padding-top: 10px;
  .box {
    width: 92%;
    min-height: 200px;
    background: url(~@/assets/images/audit/border.png) no-repeat;
    background-size: 100% 100%;
    padding: 24px 0;
    box-sizing: border-box;
    .auditor {
      width: 83%;
      padding: 10px 0;
      margin-left: 20px;
      color: #666666;
      font-weight: bold;
      i {
        font-size: 20px;
        color: #0089ff;
        vertical-align: middle;
      }
      span {
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}

.time-horizontal li b:before {
  content: "";
  position: absolute;
  top: -11px;
  left: 21%;
  width: 12px;
  height: 12px;
  // border: 2px solid #4c4c4c;
  border-radius: 8px;
  background: #0089ff;
}
</style>